import { render, staticRenderFns } from "./PaymentParamsCommandsModal.vue?vue&type=template&id=660e7f96&"
import script from "./PaymentParamsCommandsModal.vue?vue&type=script&lang=js&"
export * from "./PaymentParamsCommandsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports